<script>
 export default {
   props: {
     title: {
       type: String,
       default: () => "",
       required: true,
     }
   }
 }
</script>

<template>
  <div
      class="tag_new"
  >
    <span>{{title}}</span>
  </div>
</template>

<style scoped lang="scss">
.tag_new {
  background: #3a8ee6;
  position: absolute;
  right: 0;
  top: 0;
  width: 46px;
  padding: 10px 0 10px 0;
  text-align: center;
  color: #fff;
  font-size: 14px;
  text-transform: capitalize;
  z-index: 1;
  line-height: 16px;

  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    border-style: solid;
    border-width: 0 23px 8px;
    border-color: transparent #3a8ee6 transparent #3a8ee6;
  }
}
</style>